/* import __COLOCATED_TEMPLATE__ from './eligibility-type.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { EntityType } from '@banking/ui/workflows/investments';
import { tracked } from '@glimmer/tracking';
let EligibilityType = (_class = class EligibilityType extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "invalidSelection", _descriptor2, this);
  }
  get entityTypeOptions() {
    return [{
      value: EntityType.SOLE_PROPRIETORSHIP,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.soleProp')
    }, {
      value: EntityType.SINGLE_MEMBER_LLC,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.singleMemberLLC')
    }, {
      value: EntityType.LLC,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.llc')
    }, {
      value: EntityType.PRIVATE_COMPANY,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.privateCompany')
    }, {
      value: EntityType.PUBLIC_COMPANY,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.publicCompany')
    }, {
      value: EntityType.NONPROFIT,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.nonProfit')
    }, {
      value: EntityType.PARTNERSHIP,
      label: this.intl.t('banking.investments.automation.eligibility.entityType.dropdown.options.partnership')
    }];
  }
  continue() {
    this.validate();
    if (!this.invalidSelection) {
      return this.args.continue();
    }
  }
  close() {
    return this.args.close();
  }
  onChange(event) {
    this.args.onChange(event);
    this.validate();
  }
  validate() {
    this.invalidSelection = !this.args.entityType;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "invalidSelection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "continue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype)), _class);
export { EligibilityType as default };